import { toneOf } from "@/lib/tokens.js";
import { cx } from "@/lib/cx.js";

/*
 * The summary pill from the SUMMARY PILLS block in screenshots.html.
 *
 * Not <StatCard>: that one stacks label over value with a coloured edge down
 * the left, which is what dashboard.html and users.html use. This page's pills
 * put the icon beside the number instead, and carry no edge — close enough to
 * be worth noticing, different enough that reusing the other would visibly not
 * match the design.
 *
 * The value takes the tone's text colour only where the markup does: the
 * productive percentage and the blurred count read as green and amber, the
 * first two stay neutral.
 */
export default function ShotStat({ label, value, tone = "slate", tintValue, icon }) {
    const t = toneOf(tone);

    return (
        <article
            data-stat={label}
            className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3.5 shadow-xs dark:border-slate-800 dark:bg-slate-900"
        >
            <span className={cx("grid size-9 shrink-0 place-items-center rounded-lg", t.icon)}>
                {icon}
            </span>
            <span className="min-w-0">
                <span
                    data-stat-value
                    className={cx(
                        "block text-xl font-semibold tracking-tight",
                        tintValue && t.text,
                    )}
                >
                    {value}
                </span>
                <span className="block text-[12px] text-slate-500 dark:text-slate-400">{label}</span>
            </span>
        </article>
    );
}
